export const keycodes: any = {
  DOWN_ARROW: 40,
  UP_ARROW: 38,
  ENTER: 13,
  ESC: 27,
  TAB: 9,
  DOT: 190,
  LETTER_A: 65,
  LETTER_C: 67,
  LETTER_V: 86,
  LETTER_X: 88,
};
